import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// Public Firebase web config (safe to ship in the client) — gaif-3610e project.
export const firebaseConfig = {
  apiKey: "AIzaSyAHvRf-zRFntRi3_IMJ9FxT3xR_Ap0ftks",
  authDomain: "gaif-3610e.firebaseapp.com",
  projectId: "gaif-3610e",
  storageBucket: "gaif-3610e.firebasestorage.app",
  messagingSenderId: "734168968610",
  appId: "1:734168968610:web:1c6a35a86e86a5b0a696fb",
  measurementId: "G-CCD5K9W0DT",
};

// Web Push public VAPID key (from Cloud Messaging → Web Push certificates).
export const VAPID_KEY =
  "BEwqn30A9-RGsUGC47HmVpsfOScgCN7WOWawmJDXgvlQ-d-Yqk1iuU5-8UrsZ7P_6TuZjkT1oxF856CSmNECnqc";

let messagingPromise = null;

// Returns the Messaging instance, or null on unsupported browsers.
export const getMessagingIfSupported = async () => {
  if (messagingPromise) return messagingPromise;
  messagingPromise = (async () => {
    try {
      if (!(await isSupported())) return null;
      const app = initializeApp(firebaseConfig);
      return getMessaging(app);
    } catch (_) {
      return null;
    }
  })();
  return messagingPromise;
};
